// NOTE // takes in a status and type and returns a status to display, or a color for that status
const getStatus = (status, type) => {
  if (status === true) {
    return type === 'color' ? 'green' : 'Success'
  }
  else if (status === null) {
    return type === 'color' ? 'blue' : 'Sending'
  }
  else {
    return type === 'color' ? 'red' : 'Failure'
  }
}

// NOTE // on sending an email or text, displays a status for each recipient
export const MessageStatusDisplay = (props) => {
  // NOTE // an object with each message being an object with the contact-info (email or phone-number) as the key
  let messageStatus = props.status
  // NOTE // determines whether to use email or phone-number
  let messageType = props.type
  let display = []

  // NOTE // if message status has contact-info present
  if (messageStatus && typeof messageStatus === 'object' && Object.keys(messageStatus).length > 0) {
    let keyArr = Object.keys(messageStatus)
    console.log(keyArr)

    // NOTE // loop over each entry and create an object that can be used to display the info
    for (let i = 0; i < keyArr.length; i++) {
      const msgKey = keyArr[i];
      const message = messageStatus[msgKey]
      if (message?.status !== null) {
        let statusObj = {rloc: message.rloc || '', status: messageType === 'phone' && message.status === true ? 'Accepted by SMS provider' : getStatus(message.status), color: getStatus(message.status, 'color'), detail: message.error?.message || message.historyWarning || ''}
        statusObj[messageType] = msgKey
        display.push(statusObj)
      }
    }
  }

  return (
    <div style={{fontSize: 'large', fontWeight: 'bold'}}>
      { display && display.length > 0 ?
        display.map((key, index) => {
          let message = display[index]
          let rloc = message.rloc ? `(${message.rloc}) ` : ''
          return (
            <div key={message[messageType]}>{`${rloc}${message[messageType]}: `}<strong style={{color: message.color}}>{`${message.status}`}</strong>{message.detail && <div role="alert">{message.detail}</div>}</div>
          )
        }) :
        <div style={{fontSize: 'large'}}>Sending...</div>
      }
    </div>
  )
}